import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrivate from '@afosto/auth-react/usePrivate';
import { FormattedMessage } from 'react-intl';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import DeveloperSettings from './DeveloperSettings';
import GeneralSettings from './GeneralSettings';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const Settings = () => {
  usePrivate();

  const history = useHistory();
  const intl = useIntl();
  const location = useLocation();

  return (
    <Page
      title={intl.formatMessage(translations.title)}
      subNavigation={{
        current: location.pathname,
        tabs: [
          {
            label: intl.formatMessage(translations.subNavigation.general),
            path: '/settings',
          },
          {
            label: intl.formatMessage(translations.subNavigation.developerSettings),
            path: '/settings/developer-settings',
          },
        ],
        onChange: (e, value) => history.replace(value),
      }}
    >
      {location.pathname === '/settings' && (
        <Box mb={2}>
          <Alert severity="info">
            <FormattedMessage {...translations.alert.message} />
          </Alert>
        </Box>
      )}
      <Switch>
        <Route path="/settings/developer-settings" component={DeveloperSettings} />
        <Route path="/settings" component={GeneralSettings} />
      </Switch>
    </Page>
  );
};

export default Settings;
